import { FC, useMemo } from 'react';

import { GenericSeason, TopicalitySeriesSection } from '../../contentStack.types';
import { OnSelectVariant } from '../../hooks/useContentStackEventHandlers';

import { GenericSeriesSection } from './GenericSeriesSection';

type TopicalitySeasonSectionProps = {
  seriesData: TopicalitySeriesSection['topicalitySeries'];
  onClickVariant: OnSelectVariant;
};
export const TopicalitySeries: FC<TopicalitySeasonSectionProps> = ({ seriesData, onClickVariant }) => {
  const mappedData = useMemo(() => {
    const seasons = seriesData.seasons.map((s): GenericSeason => {
      return {
        id: s.link.split(':').pop()!,
        defaultSelected: s.defaultSelected,
        episodeCount: s.episodeCount,
        link: s.link,
        label: s.label,
      };
    });
    // Ensure some default selected
    if (!seasons.some(s => s.defaultSelected)) {
      for (const s of seasons) {
        if (s.episodeCount > 0) {
          s.defaultSelected = true;
          break;
        }
      }
    }
    return { seasons, type: 'topicality' } as const;
  }, [seriesData.seasons]);

  return <GenericSeriesSection seriesData={mappedData} onClickVariant={onClickVariant} />;
};
